import React, { PureComponent } from 'react';
import { arrayOf, bool, func, number, oneOfType, string } from 'prop-types';
import LoadableList from '../../components/LoadableList';
import { SimpleText } from '../../util/IntlMessages';
import { DATA_PER_PAGE } from '../../constants/Values';
import AddNewTemplateButton from './AddNewTemplateButton';
import TemplatesListItem from './TemplatesListItem';
import { templateType } from './types';

class TemplatesList extends PureComponent {
  static propTypes = {
    getNoticeTemplates: func,
    loading: bool,
    open: bool,
    onSelectedTemplateChange: func,
    pageCount: oneOfType([number, string]),
    recentlyAddedTemplates: arrayOf(templateType),
    showAddButton: bool,
    templates: arrayOf(templateType),
    selectedTemplateId: string,
    isTemplate: bool,
    // Non-null when the templates fetch has failed. Drives the empty-state
    // copy: error message vs neutral "no templates yet".
    fetchError: oneOfType([bool, string]),
  };

  static defaultProps = {
    getNoticeTemplates: () => {},
    onSelectedTemplateChange: () => {},
    open: true,
    pageCount: 0,
    recentlyAddedTemplates: [],
    showAddButton: false,
    templates: [],
    isTemplate: false,
    fetchError: null,
  };

  componentDidMount() {
    this.props.getNoticeTemplates();
  }

  onTemplateClick = template => {
    if (this.props.selectedTemplateId && this.props.selectedTemplateId === template.id) {
      return;
    }

    this.props.onSelectedTemplateChange(template.id);
  };

  loadMore = () => this.props.getNoticeTemplates(true);

  renderTemplates = templates =>
    templates.map(template => (
      <TemplatesListItem
        key={template.id}
        onTemplateClick={this.onTemplateClick}
        selected={this.props.selectedTemplateId && this.props.selectedTemplateId === template.id}
        template={template}
        isTemplate={this.props.isTemplate}
      />
    ));

  render() {
    if (!this.props.open) {
      return null;
    }

    const {
      loading,
      pageCount,
      recentlyAddedTemplates,
      showAddButton,
      templates,
      fetchError,
    } = this.props;

    const recentlyAddedTemplatesLength = recentlyAddedTemplates ? recentlyAddedTemplates.length : 0;
    const hasMore =
      Math.ceil((templates.length + recentlyAddedTemplatesLength) / DATA_PER_PAGE) < pageCount;

    // When the fetch has failed AND there's nothing else to show, surface a
    // distinct error copy so the user can tell a network failure apart from
    // a genuinely empty template list. The list still renders any recently-
    // added items the user just created (those live in a separate slice
    // branch and survive the failed list fetch).
    const emptyText =
      fetchError && !templates.length && !recentlyAddedTemplatesLength ? (
        <SimpleText id="messages.templatesFetchError" />
      ) : (
        <SimpleText id="messages.noTemplates" />
      );

    return (
      <div className="template-list">
        {showAddButton && <AddNewTemplateButton />}
        <LoadableList
          loading={loading}
          dataLength={templates.length || recentlyAddedTemplatesLength}
          emptyText={emptyText}
          hasMore={hasMore}
          loadMore={this.loadMore}
        >
          {this.renderTemplates(recentlyAddedTemplates)}
          {this.renderTemplates(templates)}
        </LoadableList>
      </div>
    );
  }
}

export default TemplatesList;
